import * as angular from 'angular';
import type { RoutingService } from '../App/services/mx-routing-service';
import { DashboardPageComponent } from './dashboard-page/dashboard-page.component';
import { DashboardWidgetComponent } from './dashboard-widget/dashboard-widget.component';
import { DashboardService } from './dashboard.service';
import type { Transition } from '@uirouter/angularjs';
import { WidgetConfigurationPanelComponent } from './widget-configuration-panel/widget-configuration-panel.component';
import { DashboardControlPanelComponent } from './dashboard-control-panel/dashboard-control-panel.component';
import { WidgetCategoriesPanelComponent } from './widget-categories-panel/widget-categories-panel.component';
import { DashboardConfigurationPanelComponent } from './dashboard-configuration-panel/dashboard-configuration-panel.component';

export const dashboardRouteName = 'dashboard';

export const dashboardModule = angular
	.module('mx.sb.Dashboard', [])
	.service('mx.sb.Dashboard.Service', DashboardService)
	.component(DashboardPageComponent.name, DashboardPageComponent)
	.component(DashboardWidgetComponent.name, DashboardWidgetComponent)
	.component(WidgetConfigurationPanelComponent.name, WidgetConfigurationPanelComponent)
	.component(DashboardControlPanelComponent.name, DashboardControlPanelComponent)
	.component(WidgetCategoriesPanelComponent.name, WidgetCategoriesPanelComponent)
	.component(DashboardConfigurationPanelComponent.name, DashboardConfigurationPanelComponent)
	.run([
		'mx.shell.RoutingService',
		function (routingService: RoutingService) {
			routingService.addItems([
				routingService.createRoutingItem({
					name: dashboardRouteName,
					path: '/dashboard/:navigationId',
					component: DashboardPageComponent.name,
					params: {
						navigationId: '',
					},
					resolve: [
						{
							token: 'dashboardLoader',
							policy: { when: 'EAGER', async: 'NOWAIT' },
							deps: ['$transition$', 'mx.sb.Dashboard.Service'],
							resolveFn: async ($transition$: Transition, dashboardService: DashboardService) => {
								const navigationId = $transition$.params().navigationId.toLowerCase();
								return await dashboardService.getDashboard(navigationId);
							},
						},
					],
				}),
			]);
		},
	]);
